import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const loadScannedRenderer = ({
  changes: { location, total_pallets, scanned_pallets, observations },
  ...props
}) => {
  const filteredObservations =
    observations &&
    observations.filter((observation) => observation && observation.comment.length > 0);

  return (
    <Spacer {...props}>
      <Spacer>
        {!!location && (
          <Text color="grey800" display="block">
            At {location}
          </Text>
        )}
      </Spacer>
      <Spacer>
        {total_pallets >= 0 && scanned_pallets >= 0 && (
          <div data-testid="load-scanned-display">
            <Text color="grey800" display="block">
              {scanned_pallets}/{total_pallets} pallets OK
            </Text>
            {total_pallets > scanned_pallets && (
              <Text weight="bold" color="grey800" display="block">
                {total_pallets - scanned_pallets} missing
              </Text>
            )}
          </div>
        )}
      </Spacer>
      <Spacer>
        {total_pallets > 0 && !!filteredObservations && filteredObservations.length > 0 && (
          <div>
            <Text color="grey800" display="block">
              {filteredObservations.length}/{total_pallets} pallets with observations
            </Text>
            {filteredObservations.map((observation) => (
              <Spacer mTop="XS">
                <Text weight="bold" display="block">
                  Pallet {observation.pallet_id} - Observations:
                </Text>
                {observation.comment.map((comm) => (
                  <Text display="block">{comm}</Text>
                ))}
              </Spacer>
            ))}
          </div>
        )}
      </Spacer>
    </Spacer>
  );
};

export default loadScannedRenderer;
